import React, { useState, useEffect } from 'react';
import { useConfigContext } from '../../../../contexts/ConfigContext';
import CountryTabs from '../CountryTabs';
import CountryAccordion from '../CountryAccordion';

const _isMobile = () => window.innerWidth < 577;

const CountrySelector = ({ initialRegionIndex, handleMenuVisibility, currentCountry }) => {
  const { REGIONS } = useConfigContext();
  const [selectedTabIndex, setSelectedTabIndex] = useState(initialRegionIndex);
  const [selectedAccordionIndex, setSelectedAccordionIndex] = useState(initialRegionIndex);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCountryIndex, setSelectedCountryIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  let subregions;

  if (REGIONS && REGIONS.length > 0 && typeof REGIONS[selectedTabIndex] !== 'undefined') {
    subregions = REGIONS[selectedTabIndex].subregions;
  }

  const toggleDropdown = index => {
    setDropdownOpen(prevState => !prevState);
    setSelectedCountryIndex(index);
  };

  useEffect(() => {
    setIsMobile(_isMobile());

    const resizeCallback = () => {
      setIsMobile(_isMobile());
    };

    window.addEventListener('resize', resizeCallback);

    return () => window.removeEventListener('resize', resizeCallback);
  }, [setIsMobile]);

  return isMobile ? (
    <CountryAccordion
      regions={REGIONS}
      setSelectedAccordionIndex={setSelectedAccordionIndex}
      selectedAccordionIndex={selectedAccordionIndex}
      dropdownOpen={dropdownOpen}
      selectedCountryIndex={selectedCountryIndex}
      subregions={subregions}
      toggleDropdown={toggleDropdown}
      handleMenuVisibility={handleMenuVisibility}
      currentCountry={currentCountry}
    />
  ) : (
    <CountryTabs
      regions={REGIONS}
      setSelectedTabIndex={setSelectedTabIndex}
      dropdownOpen={dropdownOpen}
      selectedCountryIndex={selectedCountryIndex}
      subregions={subregions}
      selectedTabIndex={selectedTabIndex}
      toggleDropdown={toggleDropdown}
      handleMenuVisibility={handleMenuVisibility}
      currentCountry={currentCountry}
    />
  );
};

export default CountrySelector;
